import { render, staticRenderFns } from "./ProductPricingRequestForm.vue?vue&type=template&id=21fa7bdd&"
import script from "./ProductPricingRequestForm.vue?vue&type=script&lang=js&"
export * from "./ProductPricingRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports